<template>
  <ItemsPopoverCell :items="serviceSummaries ?? []" noun="Services" />
</template>

<script setup lang="ts">
import ItemsPopoverCell from "@/shared/components/ItemsPopoverCell.vue";
import type { BenefitServiceDisplaySummary } from "../helpers";

defineProps<{
  serviceSummaries?: readonly BenefitServiceDisplaySummary[];
}>();
</script>
